import { defineMessages } from 'react-intl';

export default defineMessages({
    driversTitle: {
        id: 'endorsement.pa.view.Drivers',
        defaultMessage: 'Drivers',
    },
    driverName: {
        id: 'wmic-pe-capability-gateway-policychange-pa-react.pa-drivers-details.driverName',
        defaultMessage: 'Name',
    },
    licenseNumber: {
        id: 'wmic-pe-capability-gateway-policychange-pa-react.pa-drivers-details.licenseNumber',
        defaultMessage: 'License number',
    },
    licenseProvince: {
        id: 'wmic-pe-capability-gateway-policychange-pa-react.pa-drivers-details.licenseProvince',
        defaultMessage: 'License province',
    },
    licenseProvinceOther: {
        id: 'wmic-pe-capability-gateway-policychange-pa-react.pa-driver-license.Other',
        defaultMessage: 'Other',
    },
    atLeastOne: {
        id: 'wmic-pe-capability-gateway-policychange-pa-react.pa-drivers-details.AtLeastOne',
        defaultMessage: '&lt;span&gt;Add a minimum of &lt;b&gt;one Driver&lt;/b&gt;&lt;/span&gt;',
    },
});
